export const UserRolesEnum = Object.freeze({
  SUPER_ADMIN: "super_admin",
  USER: "user",
  LABELER: "labeler",
});
